(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.score = 0;
        this.status = "idle";
        this.initialState = initialState ? JSON.parse(JSON.stringify(initialState)) : null;
        this.state = initialState ? JSON.parse(JSON.stringify(initialState)) : this.createEmptyBoard();
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "createEmptyBoard",
            value: function createEmptyBoard() {
                return Array.from({
                    length: Game.SIZE
                }, function() {
                    return Array(Game.SIZE).fill(0);
                });
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyTiles = [];
                for(var row = 0; row < Game.SIZE; row++){
                    for(var col = 0; col < Game.SIZE; col++)if (this.state[row][col] === 0) emptyTiles.push({
                        row: row,
                        col: col
                    });
                }
                if (emptyTiles.length > 0) {
                    var _emptyTiles_Math_floor = emptyTiles[Math.floor(Math.random() * emptyTiles.length)], row1 = _emptyTiles_Math_floor.row, col1 = _emptyTiles_Math_floor.col;
                    this.state[row1][col1] = Math.random() < Game.TILE_PROBABILITY ? 2 : 4;
                }
            }
        },
        {
            key: "checkGameState",
            value: function checkGameState() {
                if (this.state.some(function(row) {
                    return row.includes(Game.WIN_TILE_VALUE);
                })) {
                    this.status = "win";
                    return;
                }
                if (!this.canMove()) this.status = "lose";
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                for(var row = 0; row < Game.SIZE; row++)for(var col = 0; col < Game.SIZE; col++){
                    if (this.state[row][col] === 0) return true;
                    if (row < Game.SIZE - 1 && this.state[row][col] === this.state[row + 1][col] || col < Game.SIZE - 1 && this.state[row][col] === this.state[row][col + 1]) return true;
                }
                return false;
            }
        },
        {
            key: "move",
            value: function move(direction) {
                if (this.status !== "playing") return;
                var previousState = JSON.stringify(this.state);
                if (direction === "left") this.state = this.shiftLeft(this.state);
                if (direction === "right") this.state = this.shiftRight(this.state);
                if (direction === "up") this.state = this.shiftUp(this.state);
                if (direction === "down") this.state = this.shiftDown(this.state);
                if (JSON.stringify(this.state) !== previousState) this.addRandomTile();
                this.checkGameState();
            }
        },
        {
            key: "shiftLeft",
            value: function shiftLeft(state) {
                var _this = this;
                return state.map(function(row) {
                    return _this.compressRow(row);
                });
            }
        },
        {
            key: "shiftRight",
            value: function shiftRight(state) {
                var _this = this;
                return state.map(function(row) {
                    return _this.compressRow((0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse()).reverse();
                });
            }
        },
        {
            key: "shiftUp",
            value: function shiftUp(state) {
                var transposed = this.transpose(state);
                var shifted = this.shiftLeft(transposed);
                return this.transpose(shifted);
            }
        },
        {
            key: "shiftDown",
            value: function shiftDown(state) {
                var transposed = this.transpose(state);
                var shifted = this.shiftRight(transposed);
                return this.transpose(shifted);
            }
        },
        {
            key: "compressRow",
            value: function compressRow(row) {
                var filtered = row.filter(function(value) {
                    return value !== 0;
                });
                for(var i = 0; i < filtered.length - 1; i++)if (filtered[i] === filtered[i + 1]) {
                    filtered[i] *= 2;
                    this.score += filtered[i];
                    filtered[i + 1] = 0;
                }
                var filtered2 = filtered.filter(function(value) {
                    return value !== 0;
                });
                return (0, $227c6742e0ff6f82$export$71511d61b312f219)(filtered2).concat((0, $227c6742e0ff6f82$export$71511d61b312f219)(Array(Game.SIZE - filtered2.length).fill(0)));
            }
        },
        {
            key: "transpose",
            value: function transpose(matrix) {
                return matrix[0].map(function(_, colIndex) {
                    return matrix.map(function(row) {
                        return row[colIndex];
                    });
                });
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.move("up");
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.move("down");
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                this.move("left");
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.move("right");
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                if (this.status === "idle") {
                    this.resetGame();
                    this.status = "playing";
                    this.addRandomTile();
                    this.addRandomTile();
                }
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.resetGame();
                this.status = "idle";
            }
        },
        {
            key: "resetGame",
            value: function resetGame() {
                this.state = this.initialState ? JSON.parse(JSON.stringify(this.initialState)) : this.createEmptyBoard();
                this.score = 0;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$var$Game.TILE_PROBABILITY = 0.9;
$3d28d7f1aac198f5$var$Game.SIZE = 4;
$3d28d7f1aac198f5$var$Game.WIN_TILE_VALUE = 2048;
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$button = document.querySelector(".button");
var $197cd56b15c33885$var$gameField = document.querySelector(".game-field");
var $197cd56b15c33885$var$gameScore = document.querySelector(".game-score");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
$197cd56b15c33885$var$button.addEventListener("click", function() {
    var isIdle = $197cd56b15c33885$var$game.getStatus() === "idle";
    $197cd56b15c33885$var$game[isIdle ? "start" : "restart"]();
    $197cd56b15c33885$var$button.textContent = isIdle ? "Restart" : "Start";
    $197cd56b15c33885$var$button.classList.toggle("start", !isIdle);
    $197cd56b15c33885$var$button.classList.toggle("restart", isIdle);
    $197cd56b15c33885$var$updateUI();
});
document.addEventListener("keydown", function(e) {
    e.preventDefault();
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    switch(e.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$updateUI();
});
function $197cd56b15c33885$var$updateUI() {
    $197cd56b15c33885$var$renderBoard();
    $197cd56b15c33885$var$updateScore();
    $197cd56b15c33885$var$updateMessages();
}
function $197cd56b15c33885$var$renderBoard() {
    var board = $197cd56b15c33885$var$game.getState();
    $197cd56b15c33885$var$gameField.querySelectorAll(".field-cell").forEach(function(cell, index) {
        var row = Math.floor(index / 4);
        var col = index % 4;
        var value = board[row][col];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell".concat(value ? " field-cell--".concat(value) : "");
    });
}
function $197cd56b15c33885$var$updateScore() {
    $197cd56b15c33885$var$gameScore.textContent = $197cd56b15c33885$var$game.getScore();
}
function $197cd56b15c33885$var$updateMessages() {
    var gameStatus = $197cd56b15c33885$var$game.getStatus();
    var messages = {
        lose: $197cd56b15c33885$var$messageLose,
        win: $197cd56b15c33885$var$messageWin,
        start: $197cd56b15c33885$var$messageStart
    };
    Object.keys(messages).forEach(function(key) {
        messages[key].classList.toggle("hidden", key !== gameStatus);
    });
}

})();
//# sourceMappingURL=index.ce3a1fcf.js.map
